export default function customerListReducer(state = { customerListState:{} }, action)  {

          switch (action.type) {
              case 'CUSTOMERLIST_STATE':
                  return {
                      customerListState: action.customerListState,
                  }
              default:
                  return state
          }
      }


// WEBPACK FOOTER //
// ./src/reducer/customerlistreducer.js